import { client } from "./utils";
import { formatAppListResponse } from "./utils/helpers";

export interface IProductInfoByRowNumber {
  clientDbId: number;
  module: string;
  rowNumber: number;
  operationCode: string;
  departmentId?: string;
  barcode: string;
  locale: string;
  version: string;
}

export const getProductInfoByRowNumber = (params: any) => {
  const query = {
    clientDbId: params.clientDbId,
    procedureName: "RGI_MSCAN_GET_BARCODE_INFO",
    data: {
      module: params.module,
      rowNumber: params.rowNumber,
      operationCode: params.operationCode,
      departmentId: params.departmentId,
      barcode: params.barcode,
      version: params.version,
      locale: params.locale
    },
  };
  return client
    .post("/client/application", query, {
      headers: {
        "accept-language": params.locale,
      },
    })
    .then(formatAppListResponse);
};

export const getProductInfoByBarcode = (params: { [name: string]: any }) => {
  const query = {
    clientDbId: params.clientDbId,
    procedureName: "RGI_MSCAN_GET_BARCODE_INFO",
    data: {
      barcode: params.barcode,
      module: params.module,
      scannedWithCamera: params.scannedWithCamera ? 1 : 0,
      departmentId: params.departmentId,
      locale: params.locale,
      version: "V3"
    },
  };
  return client
    .post("/client/application", query, {
      headers: {
        "accept-language": params.locale,
      },
    })
    .then(formatAppListResponse);
};

export const getProductInfoCustom = (params: { [name: string]: any }) => {
  const query = {
    clientDbId: params.clientDbId,
    procedureName: "RGI_MSCAN_GET_PRODUCT_INFO_CLIENT",
    data: {
      module: params.module,
      rowNumber: params.rowNumber,
      operationCode: params.operationCode,
      barcode: params.barcode,
      scannedWithCamera: params.scannedWithCamera ? 1 : 0,
      departmentId: params.departmentId
    },
  };
  return client
    .post("/client/application", query, {
      headers: {
        "accept-language": params.locale,
      },
    })
    .then(formatAppListResponse);
};